import { render, staticRenderFns } from "./RootView.vue?vue&type=template&id=bc197600&scoped=true"
import script from "./RootView.vue?vue&type=script&lang=js"
export * from "./RootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc197600",
  null
  
)

export default component.exports